export default "__VITE_ASSET__B2bmf6Th__"